import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-affidavit',
  templateUrl: './affidavit.component.html',
  styleUrls: ['./affidavit.component.scss']
})
export class AffidavitComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
    window.scroll({ top: 0 });
  }

}
